const getters = {}

export default getters



// WEBPACK FOOTER //
// ./src/store/modules/raceResume/getters.js